import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Composer from './Composer';
import Message from './Message';
import { useMutation, useSubscription } from 'react-apollo';
import {
  INSERT_MESSAGE,
  LISTEN_MESSAGES,
  UPDATE_USER_ROOM_STATUS,
} from 'graphql/chat';
import PRODUCTS from 'constant/product-types';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 130px)',
    [theme.breakpoints.down('xs')]: {
      height: 'calc(100vh - 230px)',
    },
  },
  messages: {
    flex: 1,
    overflowY: 'auto',
    padding: theme.spacing(4),
    backgroundColor: theme.palette.background['blueGray'],
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
}));

const RoomNameLabel = {
  parents_coaches: 'counseling team',
  parents_admin: 'Program Supervisor',
  admin: 'Admin',
  coaches: 'counseling team',
  groups: 'group',
  parents_fa: 'Financial Aid Counselor'
};

const PRODUCTS_LOOKUP = PRODUCTS.reduce((memo, i) => {
  memo[i.value] = i.label;
  return memo;
}, {});

const Room = ({ user, profile, room, tab, isFocused, groupRoom }) => {
  const classes = useStyles();
  const listRef = useRef();
  const { data } = useSubscription(LISTEN_MESSAGES, {
    variables: { roomId: room.id },
  });

  const [updateStatus] = useMutation(UPDATE_USER_ROOM_STATUS, {
    variables: { userId: user.id, roomId: room.id, timestamp: 'now()' },
  });
  const [addMessage] = useMutation(INSERT_MESSAGE);

  useEffect(() => {
    if (listRef.current && isFocused) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [data, isFocused]);

  useEffect(() => {
    if (isFocused) {
      updateStatus();
    }
  }, [isFocused, data]);

  const onSend = async (message, attachmentKey) => {
    window.analytics.track('Chat message received from student', {
      message,
      room_id: room.id,
      user_id: user.id,
      attachment: attachmentKey,
      length:message.length,
      product: PRODUCTS_LOOKUP[profile.product_type]
    });
    return addMessage({
      variables: {
        data: {
          message,
          room_id: room.id,
          user_id: user.id,
          attachment: attachmentKey,
        },
      },
    });
  };

  const users = [];
  if (profile.lc_id) {
    users.push({ id: profile.lc_id, display: profile.lc_user.user_first_name });
  }
  if (profile.hc_id) {
    users.push({ id: profile.hc_id, display: profile.hc_user.user_first_name });
  }

  return (
    <div className={classes.root} id="chat-room-root">
      <div className={classes.messages} ref={listRef}>
        {data?.messages.map((m) => (
          <Message user={user} message={m} userId={user.id} key={m.id} />
        ))}
      </div>
      <Composer
        users={users}
        onSend={onSend}
        tab={tab}
        placeholder={`Message ${RoomNameLabel[room.room_name]}...`}
      />
    </div>
  );
};

export default Room;
